import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FamilyGrid.css'
import {Row, Col} from 'react-flexbox-grid'
import format from '../../helpers/format'
import analytics from '../../helpers/analytics'
import config from '../../config'
import { Link, LinkIcon } from '../../components'
// import convert from '../../helpers/convert'

@CSSModules(Styles)
export default class FamilyGrid extends Component {
  static propTypes = {
    fullGrid: PropTypes.bool
  }

  constructor(props){
    super(props)
  }
  onMouseEnter = (prop) => {
    return () => {
      // this.state.onHovers[prop] = true
      const onHovers = Object.assign({},this.state.onHovers)
      onHovers[prop] = true
      this.setState({onHovers: onHovers})
      // console.log('enter:',onHovers )
    }
  }

  onMouseLeave = (prop) => {
    return () => {
      const onHovers = Object.assign({},this.state.onHovers)
      delete onHovers[prop]
      this.setState({onHovers: onHovers})
      // console.log('leave:',onHovers )
      // console.log('leave:',this.state.onHovers )
    }
  }

  renderCompanies = () => {
    return config.familyFunds.map((c,idx) =>{
      return this.renderCompany(idx, c.fund_family_name, c.label, c.t_all_asset_sum, c.t_all_weight_total, c.num_equity_funds, 5)
    })
  }

  renderLogo = (title) => {
    const fileName = format.imgPath(title)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }
    if (hasLogo) {
      return (
        <img
          styleName='box-title-logo'
          src={companyLogo}
          alt={title}
        />
      )
    } else {
      console.log(fileName)
      return (
        <span>{title}</span>
      )
    }
  }


  renderCompany = (idx, title, label, asset, perc, numFunds, rating) => {
    const safeName = encodeURIComponent(title)
    return(
      <Col key={idx} styleName='companies-box-wrap' xs={12} sm={4}>
        <Link
          onMouseEnter={this.onMouseEnter('company-'+idx)}
          onMouseLeave={this.onMouseLeave('company-'+idx)}
          log={analytics.eventToFamily(label)}
          to={config.routes.families+'?q='+safeName}
          styleName='companies-link'
          title={label}>
          <div styleName={'companies-box-'+rating}>
            <div styleName='box-title-wrapper'>
              { this.renderLogo(title, label) }
            </div>
            <div styleName='box-subtitle'>
              {numFunds} equity funds analyzed
            </div>
            <div styleName='box-subtitle'>
              <strong>{format.perc(perc, true)}</strong> overall tobacco and
              studios exposure
            </div>
            <div styleName='box-subtitle'>
              <strong>
                {format.money(asset, true, 'US Dollar', false, 0)}
              </strong> in tobacco and studios
            </div>
            <div styleName='learn-more-wrap'>
              <div styleName={'learn-more-'+rating}>
                More<LinkIcon />
              </div>
            </div>
          </div>
        </Link>
      </Col>
    )
  }
 
  renderAddtl = () => {
    if (!this.props.fullGrid) {
      return null
    }

    const allFams = config.formOptions.fundFamilyAll
    const filteredFams = allFams.reduce((arr, el) => {
      if (el.name !== 'All funds') {
        arr.push(el)
      }
      return arr
    }, [])

    return (
      <div>
        <div styleName='addtl-fam-info'>
          <strong>We analyze funds from over one hundred asset managers. See the full list below:</strong>
        </div>
        <div styleName='addtl-fam-links'>
          { filteredFams.map( (el, ix) => {
            return (
              <Link
                to={config.routes.list+'?srt=badge_count&ff='+el.name}
                title={el.name}
                key={el.name}
                strong={true}
              >
                <div styleName='addtl-fam-link'>
                  { el.name }<LinkIcon />
                </div>
              </Link>
            )
          }) }
        </div>
      </div>
    )
  }
 
  render() {
    return (
      <div styleName='companies'>
        <div styleName='companies-anchor' id='companies'/>
        <div styleName='companies-inner'>
          <div styleName='companies-title'>
            The largest mutual fund managers have billions invested in tobacco stocks
          </div>
          <Row styleName='companies-boxes'>
            { this.renderCompanies() }
          </Row>
          { this.renderAddtl() }
        </div>
      </div>
    )
  }
}
